<template>
  <div class="column__wrap">
    <div
      v-for="column in columnList"
      :key="column.title"
      class="column">
      <!-- 栏目标题 -->
      <h2 class="column__title">{{ column.title }}</h2>
      <!-- 栏目子项 -->
      <ul class="column__items">
        <li
          v-for="item in column.items"
          :key="item.name"
          :class="[{'slot_class': item.slotClass}, 'item']"
          @click="handlerClick(item)">
          <div class="item__wrap">
            <i :class="['item__icon', item.icon]"></i>
            <span class="item__name">{{ item.name }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    columnList: {
      required: true,
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    // 项目点击，路由跳转
    handlerClick (item) {
      if (item.link) {
        this.$router.push(item.link)
        return
      }
      if (item.href) {
        window.location.href = item.href
      }
    }
  }
}
</script>
